import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" An error occurred ")

import {
  computed, PropType, toRef, watch,
} from 'vue';

import {
  AsyncFunc, Options, OptionsGetterAsyncProp,
} from './optionsGetter.types';


export default /*#__PURE__*/_defineComponent({
  props: {
  options: {
    type: Array as PropType<Options>,
    required: false,
    default: undefined,
  },
  async: {
    type: Object as PropType<OptionsGetterAsyncProp>,
    required: false,
    default: undefined,
  },
},
  setup(__props) {

const props = __props



// We can't use computed function here
// 'cause Vue starts throwing us warnings in the runtime
// with something with incorrect usage of onBeforeUnmount events...
// IDK why it happens, so a solution is just to do almost the same
// but in `watch` function
let async: ReturnType<AsyncFunc> | null = null;

const asyncProp = toRef(props, 'async');
watch(asyncProp, (_async) => {
  if (_async) {
    async = _async.func();
  } else {
    async = null;
  }
}, { immediate: true });

const data = computed(() => {
  if (async) {
    return async.data.value;
  }

  return null;
});

const loading = computed<boolean>(() => (async ? async.loading.value : false));
const error = computed(() => (async?.error.value ? async.error.value : null));

const options = computed(() => {
  if (props.async && data
  ) {
    return props.async.mapper(data.value);
  }

  return props.options || [];
});

return (_ctx: any,_cache: any) => {
  return (!_unref(loading) && !!_unref(error))
    ? _renderSlot(_ctx.$slots, "error", {
        key: 0,
        error: _unref(error)
      }, () => [
        _hoisted_1
      ])
    : _renderSlot(_ctx.$slots, "default", {
        key: 1,
        options: _unref(options),
        loading: _unref(loading)
      })
}
}

})